module.exports = __webpack_public_path__ + "media/assets/images/layout/post-bg-3453da0c0e12c778ddc11b5c5b4fd20a.jpg";